module.exports = __webpack_public_path__ + "img/cs.5c0f9497.png";